export function fullUrl(url?: string | null): string {
    if (!url) return '';
    if (url.includes('https://') || url.includes('http://')) return url;

    const protocolPrefix = 'https://';
    return protocolPrefix + url;
}
